const documentos = [
  {
    slug: "entrega-servicio-cliente",
    titulo: "Entrega de Servicio a Cliente",
    pdf: "06-implementacion-y-entrega-de-servicios-a-cliente.pdf",
  },
  {
    slug: "entrega-servicio-cliente-raci",
    titulo: "Entrega de Servicio a Cliente Matriz RACI",
    pdf: "06-entrega-de-servicios-a-cliente-RACI.pdf",
  },
  {
    slug: "soporte-cliente-total",
    titulo: "Soporte a Cliente Total",
    pdf: "07-soporte-a-cliente-total.pdf",
  },
];

export default documentos;
